import isWidgetHalfVisible from '../utils/is-widget-half-visible'
import logger from '../utils/logger'
import { pub, sub, unsub } from '../utils/pub-sub'
import widgetPrototypes from './prototypes'

function SysPsvButton({ id, node, container, window, config }) {
  // never change the eternalId!
  // it is used to identify the widget in tracking events - no matter of internal technical changes inside the SDK
  this.eternalId = config.eternalId || 'deprecated-sys-psv-button'
  this.type = config.type || 'SysPsvButton'
  this.id = id
  this.node = node
  this.container = container
  this.window = window
  this.config = config
  this.widgetConfiguration = {
    ...(window._8select.config.widgets[config.type] || {}),
  }
  this.isActive = false
  this.isDestroyed = false

  sub('app:content:found', this.id, context => {
    if (
      context &&
      (context.widgetType === 'Set' || context.widgetType === 'SetCompose' || context.widgetType === 'SysPsv')
    ) {
      this.activate()
    }
  })
  sub('app:content:notFound', this.id, context => {
    // @todo if there are multiple widgets - this should not be destroyed
    if (
      context &&
      (context.widgetType === 'Set' || context.widgetType === 'SetCompose' || context.widgetType === 'SysPsv')
    ) {
      this.destroy()
    }
  })
  sub('app:error', this.id, context => {
    if (!context || context.widgetId !== id) {
      return
    }
    this.destroy()
  })

  sub('widget:destroy', this.id, context => {
    if (
      context &&
      (context.widgetType === 'Set' || context.widgetType === 'SetCompose' || context.widgetType === 'SysPsv')
    ) {
      // if widget is my target
      this.destroy()
    }
  })

  sub('widget:removedFromDom', this.id, context => {
    if (!context || context.widgetId !== id) {
      return
    }
    this.destroy()
  })

  for (const subscription of this.widgetConfiguration.subscriptions || []) {
    sub(subscription.event, this.id, subscription.callback.bind(this))
  }
}

Object.assign(SysPsvButton.prototype, widgetPrototypes)

SysPsvButton.prototype.load = function(eltxLoadCallback) {
  this.node.setAttribute('data-8select-widget-state', 'loaded')
  eltxLoadCallback()

  this.handleWidgetClick = function() {
    this.window.eightlytics('clickWidget', {}, undefined, this.getWidgetUuid())
  }.bind(this)
}

SysPsvButton.prototype.activate = function() {
  if (this.isActive === true) {
    return
  }
  this.isActive = true

  this.node.style.display = 'block'
  this.addEventListener()
  pub('widget:activate', { widgetId: this.id, widgetType: this.type })
}

SysPsvButton.prototype.addEventListener = function() {
  try {
    const widgetUuid = this.getWidgetUuid()
    const viewWidgetTimeout = () =>
      setTimeout(() => {
        const widgetHasBeenSeen = isWidgetHalfVisible(this)
        if (widgetHasBeenSeen) {
          pub('widget:view', { widgetId: this.id, widgetType: this.type })

          return this.window.eightlytics('viewWidget', {}, undefined, widgetUuid)
        }
        viewWidgetTimeout()
      }, 300)
    viewWidgetTimeout()

    this.node.addEventListener('click', this.handleWidgetClick)
  } catch (error) {
    logger('addEventListener failed', { widgetId: this.id, widgetType: this.type, error })
  }
}

SysPsvButton.prototype.destroy = function() {
  if (this.isDestroyed === true) {
    return
  }
  this.isDestroyed = true

  try {
    unsub(this.id)

    this.node.innerHTML = ''

    this.node.removeAttribute('data-8select-widget-state')

    this.node.removeEventListener('click', this.handleWidgetClick)

    pub('widget:destroy', { widgetId: this.id, widgetType: this.type })
  } catch (error) {
    logger('Error during widget destroy', { widgetConfiguration: this.widgetConfiguration, error })
  }
}

export default SysPsvButton
